import React from "react";

export const PluginIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 18.3327V14.166"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 6.66602V1.66602"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 6.66602V1.66602"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 6.66602V10.8327C15 11.7167 14.6488 12.5646 14.0237 13.1897C13.3986 13.8148 12.5507 14.166 11.6667 14.166H8.33333C7.44928 14.166 6.60143 13.8148 5.97631 13.1897C5.35119 12.5646 5 11.7167 5 10.8327V6.66602H15Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
